// extracted by mini-css-extract-plugin
export default {"study":"study-form_study__ZJDeZ","row":"study-form_row__fyhqh","containerField":"study-form_containerField__cwTjX","checkbox":"study-form_checkbox__5stEO"};